

<script>
export default {
  components: {},

  data: () => ({}),

  created() {},
};
</script>
<template>
  <v-row>
    <v-col cols="12" md="12">
      <AppPageContainer title="Sample Page">
        <div class="pa-7 pt-1">
          <!-- <p class="text-body-1">This is a sample page</p> -->
        </div>
      </AppPageContainer>
      <!-- <br /> -->

    </v-col>
  </v-row>
</template>
